import { render, staticRenderFns } from "./FourOFour.vue?vue&type=template&id=4d2d7e4d&scoped=true&"
import script from "./FourOFour.vue?vue&type=script&lang=js&"
export * from "./FourOFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2d7e4d",
  null
  
)

export default component.exports